export const channel_preview_logo_url = 'https://tv.briz.ua/logo/';
export const AmplitudeKey = process.env.REACT_APP_AMPLITUDE_KEY || null;


// WEBPACK FOOTER //
// ./src/config.js